import React, { FC } from 'react';
import { Block, Title, Text, Name, Position, Avatar } from './Review.style';
import { SectionContent } from '../../../types';
import { IMAGE_PATH } from '../../../constants/config';
import { IsVisible } from '../../';

interface SectionParams {
  content: SectionContent[];
  offset?: number;
}

export const Review: FC<SectionParams> = ({ content, offset = 0 }) => {
  return (
    <Block>
      {content.map((item, index) => {
        return (
          <IsVisible key={String(index)} index={index} offset={offset}>
            <Avatar src={item.image && item.image.indexOf('://') > 0 ? item.image : IMAGE_PATH + item.image} />
            <Text>— {item.text}</Text>
            <Title>
              <Name>{item.title}</Name>
              <Position>{item.subtitle}</Position>
            </Title>
          </IsVisible>
        );
      })}
    </Block>
  );
};
